import script from "./NotificationProvider.vue?vue&type=script&lang=tsx"
export * from "./NotificationProvider.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__